import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { difference } from 'underscore';
import classnames from 'classnames';

import { Icon } from 'bv-components';
import { handleCta } from 'bv-services';

import Badge from './badge';
import Tooltip from './tooltip';

const screenSizes = ['Small', 'Medium', 'Large', 'X-Large'];
const getHiddenClasses = (layout) => {
  const visibleSizes = layout.split('$');
  const hiddenSizes = difference(screenSizes, visibleSizes);
  return hiddenSizes.map((size) => `floating-nav__item--hidden-${size.toLocaleLowerCase().replace('-', '')}`);
};

const NavigationButtonView = (props) => {
  const {
    active, cta, icon, hasBadge, hasTooltip, label, layout,
  } = props;

  const onClick = useCallback(() => {
    handleCta(cta);
  });

  const className = classnames('floating-nav__item bvs-link', getHiddenClasses(layout), {
    'floating-nav__item--active': active,
  });

  return (
    <div className={className} onClick={onClick}>
      <Icon id={icon} type="floating-nav" />
      <Icon id={icon} className="floating-nav__medium-icon" {...{ [active ? 'active' : 'inverted']: true }} />
      {hasBadge && <Badge {...props} />}
      {hasTooltip && <Tooltip {...props} />}
      <span className="floating-nav__item-text">{label}</span>
    </div>
  );
};

NavigationButtonView.propTypes = {
  label: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  click: PropTypes.func.isRequired,
  hasBadge: PropTypes.bool.isRequired,
  hasTooltip: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  cta: PropTypes.instanceOf(Object).isRequired,
  layout: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default NavigationButtonView;
